// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3RFqO","signatureButtonsRight":"ModalSign_signatureButtonsRight__1CGZj"};